import { businessConstants } from '../constants';

const initialState = {
    fetchingBusinessCases: false,
    businessCases: null,
    fetchingBusinessCasesError: null,

    creatingBusinessCase: false,
    creatingBusinessCaseError: null,

    updatingBusinessCase: false,
    updatingBusinessCaseError: null,

    deletingBusinessCase: false,
    deletingBusinessCaseError: null,

    assemblingCase: false,
    assembledBusinessCase: null,
    assemblingCaseError: null,

    assemblingCases: false,
    assembledBusinessCases: [],
    assemblingCasesError: null,

    selectedBusinessCaseId: null,

    businessCases: [],
    bcWarmStatuses: {}, // { [businessCaseId]: 'cold' | 'warming' | 'ready' | 'failed' }
};

export function business(state = initialState, action) {
    switch (action.type) {
        case businessConstants.GET_BUSINESS_CASE_REQUEST: {
            return {
                ...state,
                fetchingBusinessCases: true,
                fetchingBusinessCasesError: null,
            };
        }

        case businessConstants.GET_BUSINESS_CASE_SUCCESS: {
            return {
                ...state,
                fetchingBusinessCases: false,
                businessCases: action.businessCases,
                fetchingBusinessCasesError: null,

                assembledBusinessCases: [],
                assembledBusinessCase: null,
            };
        }

        case businessConstants.GET_BUSINESS_CASE_FAILURE: {
            return {
                ...state,
                fetchingBusinessCases: false,
                fetchingBusinessCasesError: action.error,
            };
        }

        case businessConstants.CREATE_BUSINESS_CASE_REQUEST: {
            return {
                ...state,
                creatingBusinessCase: true,
                creatingBusinessCaseError: null,
            };
        }
        case businessConstants.CREATE_BUSINESS_CASE_SUCCESS: {
            return {
                ...state,
                creatingBusinessCase: false,
                businessCases: action.businessCases,
            };
        }
        case businessConstants.CREATE_BUSINESS_CASE_FAILURE: {
            return {
                ...state,
                creatingBusinessCase: false,
                creatingBusinessCaseError: action.error,
            };
        }

        case businessConstants.UPDATE_BUSINESS_CASE_REQUEST: {
            return {
                ...state,
                updatingBusinessCase: true,
                updatingBusinessCaseError: null,
            };
        }
        case businessConstants.UPDATE_BUSINESS_CASE_SUCCESS: {
            return {
                ...state,
                updatingBusinessCase: false,
                businessCases: action.businessCases,

                //  invalidate compiled results because inputs changed
                assembledBusinessCase: null,
                assembledBusinessCases: [], // optional, but consistent with GET/DELETE behavior
                assemblingCaseError: null,
                assemblingCasesError: null,
            };
        }
        case businessConstants.UPDATE_BUSINESS_CASE_FAILURE: {
            return {
                ...state,
                updatingBusinessCase: false,
                updatingBusinessCaseError: action.error,
            };
        }

        case businessConstants.DELETE_BUSINESS_CASE_REQUEST: {
            return {
                ...state,
                deletingBusinessCase: true,
                deletingBusinessCaseError: null,
            };
        }
        case businessConstants.DELETE_BUSINESS_CASE_SUCCESS: {
            return {
                ...state,
                deletingBusinessCase: false,
                businessCases: action.businessCases,

                assembledBusinessCases: [],
                assembledBusinessCase: null,
                assemblingCasesError: null,
                assemblingCaseError: null,
            };
        }
        case businessConstants.DELETE_BUSINESS_CASE_FAILURE: {
            return {
                ...state,
                deletingBusinessCase: false,
                deletingBusinessCaseError: action.error,
            };
        }

        case businessConstants.DELETE_SCENARIO_FROM_BUSINESS_CASES: {
            return {
                ...state,
                businessCases: [...action.businessCaseStructure],
            };
        }

        case businessConstants.ASSEMBLE_BUSINESS_CASE_REQUEST: {
            return {
                ...state,
                assemblingCase: true,
                assemblingCaseError: null,
            };
        }
        case businessConstants.ASSEMBLE_BUSINESS_CASE_SUCCESS: {
            return {
                ...state,
                assemblingCase: false,
                assembledBusinessCase: action.assembledBusinessCase,
            };
        }
        case businessConstants.ASSEMBLE_BUSINESS_CASE_FAILURE: {
            return {
                ...state,
                assemblingCase: false,
                assemblingCaseError: action.error,
            };
        }
        case businessConstants.CLEAR_ASSEMBLED_BUSINESS_CASE: {
            const id = Number(action.payload);
            return {
                    ...state,
                    assembledBusinessCase:
                        Number(state.assembledBusinessCase?.business_case_id) === id
                            ? null
                            : state.assembledBusinessCase,
                    assembledBusinessCases: (state.assembledBusinessCases || []).filter(
                        (bc) => Number(bc.business_case_id) !== id
                    ),
                };
            }

        case businessConstants.ASSEMBLE_BUSINESS_CASES_REQUEST: {
            return {
                ...state,
                assemblingCases: true,
                assemblingCasesError: null,
            };
        }
        
        case businessConstants.ASSEMBLE_BUSINESS_CASES_SUCCESS: {
            const incoming = action.assembledBusinessCases || [];
            const existing = state.assembledBusinessCases || [];

            const keyOf = (bc) => Number(bc?.business_case_id);

            const byId = new Map(existing.map((bc) => [keyOf(bc), bc]));
            incoming.forEach((bc) => byId.set(keyOf(bc), { ...bc, business_case_id: keyOf(bc) }));

            return {
                ...state,
                assemblingCases: false,
                assembledBusinessCases: Array.from(byId.values()),
                assemblingCasesError: null,
            };
            }

        case businessConstants.ASSEMBLE_BUSINESS_CASES_FAILURE: {
            return {
                ...state,
                assemblingCases: false,
                assemblingCasesError: action.error,
            };
        }
        case businessConstants.CLEAR_ASSEMBLED_BUSINESS_CASES: {
            return {
                ...state,
                assemblingCases: false,
                assemblingCasesError: null,
                assembledBusinessCases: [],
                assembledBusinessCase: null,
            };
        }
        
        case businessConstants.BUSINESS_SET_SELECTED_ID:
            return { ...state, selectedBusinessCaseId: action.payload };
        
        case businessConstants.BUSINESS_CLEAR_SELECTED_ID:
            return { ...state, selectedBusinessCaseId: null };

        default: {
            return state;
        }

       case businessConstants.BC_WARM_STATUS_UPDATED:
        return {
            ...state,
            bcWarmStatuses: {
                ...state.bcWarmStatuses,
                [action.businessCaseId]: action.status,
            },
        };

    case businessConstants.BC_WARM_STATUSES_UPDATED:
        const statuses = {};
        action.statuses.forEach(({ businessCaseId, status }) => {
            statuses[businessCaseId] = status;
        });
        return { ...state, bcWarmStatuses: statuses };

    }
    
}
